import { Link } from "react-router-dom";
import { supabase } from "@/lib/supabase";

export default function AccessDenied() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="text-center max-w-sm">
        <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
          <i className="ri-shield-keyhole-line text-2xl" />
        </div>
        <h1 className="font-display text-2xl font-bold text-foreground-950 mb-2">
          Không có quyền truy cập
        </h1>
        <p className="text-sm text-foreground-600 font-body mb-6">
          Tài khoản này không phải quản trị viên. Chỉ siêu quản trị duy nhất mới được vào trang này.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-block px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-label text-sm font-medium rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            Về trang chủ
          </Link>
          <button
            onClick={() => supabase.auth.signOut()}
            className="inline-block px-6 py-3 text-sm font-label font-medium text-foreground-600 hover:text-foreground-900 border border-background-300/60 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            Đăng xuất
          </button>
        </div>
      </div>
    </div>
  );
}